export const SET_OUTLET_ID = 'SET_OUTLET_ID';
export const SET_BATCH_CONFIG = 'SET_BATCH_CONFIG';